module.exports = __webpack_public_path__ + "static/barista-job-description-24ed94c739446f58d313018b955e6eb5.jpg";